import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenus = () => {
    setIsOpen(false);
    setServicesOpen(false);
  };

  return (
    <nav className="navbar sticky-navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/images/logo.png" alt="Wedding Logo" className="logo-img" />
        </Link>

        {/* Hamburger Menu Button */}
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        {/* Navigation Menu */}
        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/whoiam" className="nav-link" onClick={closeMenus}>
              Who I Am
            </Link>
          </li>
          <li className="nav-item services-dropdown" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
            <span className="nav-link" onClick={() => setServicesOpen(!servicesOpen)}>
              Services <i className="fas fa-caret-down" style={{marginLeft: '6px'}}></i>
            </span>
            <ul className={servicesOpen ? 'dropdown-menu show' : 'dropdown-menu'}>
              <li><Link to="/services/weddings" className="dropdown-link" onClick={closeMenus}>Weddings</Link></li>
              <li><Link to="/services/christening" className="dropdown-link" onClick={closeMenus}>Christening</Link></li>
              <li><Link to="/services/newborn" className="dropdown-link" onClick={closeMenus}>Newborn</Link></li>
              <li><Link to="/services/real-estate" className="dropdown-link" onClick={closeMenus}>Real Estate</Link></li>
              <li><Link to="/services/b2b" className="dropdown-link" onClick={closeMenus}>B2B</Link></li>
            </ul>
          </li>
          <li className="nav-item">
            <Link to="/gallery" className="nav-link" onClick={closeMenus}>
              Gallery
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" className="nav-link" onClick={closeMenus}>
              Blog
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/pricing" className="nav-link" onClick={closeMenus}>
              Pricing
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={closeMenus}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
